// extracted by mini-css-extract-plugin
module.exports = {"tabs":"Tabs_tabs__sQR4X","tabs__list":"Tabs_tabs__list__8TlaY","tabs__item":"Tabs_tabs__item__3chHS","tabs__button":"Tabs_tabs__button__Z-94n","tabs__bg":"Tabs_tabs__bg___9N3F"};